module.exports = __webpack_public_path__ + "static/media/Film-and-Digital-Times-Logo.f9b4b2fb.svg";